import React, { useEffect, useRef, useState } from 'react'
import SelectSearch, { fuzzySearch } from 'react-select-search'
import { toast } from 'react-toastify'
import SqaureLoader from '../../../../components/Loader/SqaureLoader'
import { addUsers, getChefsUsers } from '../../../../services/Affectations/AffectationAPI'
import { myRnId } from '../../../../utils/DateUtils'

export default function AddAffectationUser({ setShow, t }) {
    const [code, setCode] = useState("AffUser-" + myRnId())
    const [codeMerch, setcodeMerch] = useState("")
    const [codeChef, setcodeChef] = useState("")
    const [listeMerch, setlisteMerch] = useState([])
    const [listeChefs, setlisteChefs] = useState([])
    //------------Loading ----------------
    const [loading, setloading] = useState(true)
    const { searchInput1, searchInput2 } = useRef();

    const saveData = () => {
        if(codeChef !== "" && codeMerch !==""){
            const data = {
                code : code,
                chef_code : codeChef,
                user_code : codeMerch
            }
            addUsers(data).then((result) => {
                if(result?.data?.success === 1){
                    toast("added",{type:"success",position:"top-right"})
                    setShow(false)
                }else {
                    toast("error",{type:"error",position:"top-right"})

                }
            }).catch((err) => {
                console.log(err)
            });
        }
    }
    useEffect(() => {
        getChefsUsers().then((result) => {
            if (result?.data?.success === 1) {
                setlisteMerch(result?.data?.users)
                setlisteChefs(result?.data?.chefs)
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            setloading(false)
        })
    }, [])
    // Handle Change MERCHANDISEUR
    const handleChangeMerchandiseurs = (...args) => {
        setcodeMerch(args[1].value)
    };
    // Handle Change chef
    const handleChangeChef = (...args) => {
        setcodeChef(args[1].value)
    };
    return (
        <div className="modal fade" id="addUser" tabIndex={-1} role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="addUser"> Affectation utilisateurs aux chefs  </h5>
                        <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={() => setShow(false)}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {loading ? <SqaureLoader /> : (
                            <form>

                                <div className='row'>
                                    <div className='col-12'>
                                        <div className="form-group">
                                            <label className="mr-2 mt-1 mb-sm-1"> {t('rapports.code')}<span className="text-danger">*</span></label>
                                            <input type="text" value={code} readOnly disabled className="form-control" />

                                        </div>
                                    </div>


                                    <div className='col-12'>
                                        <div className="form-group">
                                            <label className="form-control-label">Chef :</label>
                                            <SelectSearch
                                                value={codeChef}
                                                options={listeChefs}
                                                search
                                                ref={searchInput1}
                                                onChange={handleChangeChef}
                                                filterOptions={fuzzySearch}
                                                emptyMessage={() => <div style={{ textAlign: 'center', fontSize: '0.8em' }}>{t('Zoning.Aucunresultat')}</div>}
                                                placeholder="Liste Chefs"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className="form-group">
                                            <label className="form-control-label">Merchandiseur :</label>
                                            <SelectSearch
                                                value={codeMerch}
                                                options={listeMerch}
                                                search
                                                ref={searchInput2}
                                                onChange={handleChangeMerchandiseurs}
                                                filterOptions={fuzzySearch}
                                                emptyMessage={() => <div style={{ textAlign: 'center', fontSize: '0.8em' }}>{t('Zoning.Aucunresultat')}</div>}
                                                placeholder="Liste Merchandiseurs"
                                            />
                                        </div>
                                    </div>
                                </div>

                            </form>
                        )}

                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={() => saveData()} ><i className='ti-save mr-1' /> {t('rapports.enregistrer')} </button>
                        <button type="button" className="btn btn-secondary" data-dismiss="modal" onClick={() => setShow(false)}> <i className='ti-close mr-1' /> {t('Routings.annueler')}</button>

                    </div>
                </div>
            </div>
        </div>
    )
}
